import { render, staticRenderFns } from "./BimetallicViz.vue?vue&type=template&id=52a8b8d7&scoped=true"
import script from "./BimetallicViz.vue?vue&type=script&lang=js"
export * from "./BimetallicViz.vue?vue&type=script&lang=js"
import style0 from "./BimetallicViz.vue?vue&type=style&index=0&id=52a8b8d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a8b8d7",
  null
  
)

export default component.exports